import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from '~/app/store'
import { DATA_TABLE_DEFAULTS } from '~/constants/dataTableSettings'
import { isJsonString } from '~/utils'

const initialState: { pageSize: number; pageOptions: number[] } = isJsonString(localStorage.getItem('pageSetting') as string)
  ? JSON.parse(localStorage.getItem('pageSetting') as string)
  : {
      pageSize: 20,
      pageOptions: DATA_TABLE_DEFAULTS.PageSizeOptions
    }

const LicenseSlice = createSlice({
  name: 'pageSetting',
  initialState,
  reducers: {
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload
      localStorage.setItem('pageSetting', JSON.stringify(state))
    },

    setPageOptions: (state, action: PayloadAction<number>) => {
      if (!state.pageOptions.includes(action.payload)) {
        state.pageOptions[DATA_TABLE_DEFAULTS.PageSizeOptions.length] = action.payload
      }
      state.pageSize = action.payload
      localStorage.setItem('pageSetting', JSON.stringify(state))
    }
  }
})

export const pageSetting = (state: RootState) => state.pageSetting
export const { setPageSize, setPageOptions } = LicenseSlice.actions

export default LicenseSlice.reducer
